export default {
    empty: "Nothing to approve",
    saved: "Approvals submitted",
    review: "",
    message: {
        message: ""
    },
    card: {
        name: {
            label: "Name"
        },
        date: {
            label: "Date"
        },
        details: {
            label: "Details"
        },
        price: {
            label: "Price"
        },
        manager: {
            label: "Manager"
        },
        requested: {
            label: "Requested by"
        },
        history: {
            cta: {
                load: "Prior approvals",
                loading: "Loading",
                show: "Prior approvals",
                hide: "Prior approvals"
            },
            approvals: {
                empty: "No prior approvals",
                item: {
                    status: {
                        approver: "by {approver}",
                        system: "Help Desk",
                        approved: "Approved",
                        rejected: "Not Approved",
                        unrequired: "Approval Not Required",
                        reason: "Reason",
                        transferred: "Transferred"
                    }
                }
            }
        },
        reason: {
            label: "Reason",
            placeholder: "Fill reason"
        },
        cta: {
            approve: {
                cta: "Approve",
                processing: "Saving"
            },
            disapprove: {
                cta: "Not Approve",
                processing: "Saving"
            }
        },
        saved: "Approvals submitted"
    }
}